import { ReactNode } from 'react'
import { Box, Button, IconButton, Stack, Table, TableBody, TableCell, TableRow, Typography } from '@mui/material'
import { ExpandLess, ExpandMore } from '@mui/icons-material'

type SectionShellProps = {
  title: string
  open: boolean
  onToggleOpen: () => void
  hasFooterToggle: boolean
  footerLabel: string
  ncols: number
  testId: string
  children: ReactNode
}

const SectionShell = ({
  title,
  open,
  onToggleOpen,
  hasFooterToggle,
  footerLabel,
  ncols,
  testId,
  children,
}: SectionShellProps) => (
  <Box sx={{ border: 1, borderColor: 'divider', borderRadius: 1, overflow: 'hidden' }} data-testid={testId}>
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      onClick={onToggleOpen}
      sx={{
        px: 2,
        py: 1,
        bgcolor: 'primary.main',
        color: 'primary.contrastText',
        borderBottom: 1,
        borderColor: 'divider',
        cursor: 'pointer',
        userSelect: 'none',
      }}
      data-testid={`${testId}-header`}
    >
      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
        {title}
      </Typography>
      <IconButton
        size="small"
        onClick={(e) => {
          e.stopPropagation()
          onToggleOpen()
        }}
        sx={{ color: 'inherit' }}
        aria-label={open ? `Collapse ${title}` : `Expand ${title}`}
        data-testid={`${testId}-header-toggle`}
      >
        {open ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
      </IconButton>
    </Stack>
    <Table size="small" sx={{ '& td, & th': { py: 0.25, px: 1 } }}>
      {children}
      {hasFooterToggle && (
        <TableBody>
          <TableRow>
            <TableCell
              colSpan={ncols}
              sx={{
                textAlign: 'left',
                borderTop: 1,
                borderColor: 'divider',
                bgcolor: 'action.hover',
              }}
            >
              <Button
                size="small"
                onClick={onToggleOpen}
                startIcon={open ? <ExpandLess /> : <ExpandMore />}
                data-testid={`${testId}-toggle`}
              >
                {open ? 'Show less' : footerLabel}
              </Button>
            </TableCell>
          </TableRow>
        </TableBody>
      )}
    </Table>
  </Box>
)

export default SectionShell
